import loadable from '@loadable/component';

/* prefetch start */
export const KycModal = loadable(
  () =>
    import(
      /* webpackChunkName: "KycModal" */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ 'components/kycModal/kycModal'
    )
);

export const DeltaIndiaStrip = loadable(
  () =>
    import(
      /* webpackChunkName: "DeltaIndiaStrip" */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ 'components/DeltaIndiaStrip/DeltaIndiaStrip'
    )
);

export const TradingViewPrimaryHeader = loadable(
  () =>
    import(
      /* webpackChunkName: "TradingViewPrimaryHeader " */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ 'components/primaryHeader/partials/tradingviewHeader'
    )
);

export const PrimaryHeader = loadable(
  () =>
    import(
      /* webpackChunkName: "PrimaryHeader" */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ 'components/primaryHeader'
    )
);

export const PrimaryHeaderMobile = loadable(
  () =>
    import(
      /* webpackChunkName: "PrimaryHeaderMobile" */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ 'components/primaryHeaderMobile'
    )
);

export const LiquidationRiskBanner = loadable(
  () =>
    import(
      /* webpackChunkName: "LiquidationRiskBanner " */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ 'components/portfolio/liquidation_risk_banner'
    )
);

export const AccountHeader = loadable(
  () =>
    import(
      /* webpackChunkName: "AccountHeader " */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ 'components/Header/account_header'
    )
);
/* prefetch end */

export const GenericPopup = loadable(
  () =>
    import(
      /* webpackChunkName: "GenericPopup" */ /* webpackMode: "lazy" */ 'components/trade/generic_popup'
    )
);

export const CurrencyConverter = loadable(
  () =>
    import(
      /* webpackChunkName: "CurrencyConverter" */ /* webpackMode: "lazy" */ 'containers/currency_converter'
    )
);

export const KycUpgradeCountdownStrip = loadable(
  () =>
    import(
      /* webpackChunkName: "KycUpgradeCountdownStrip" */ /* webpackMode: "lazy" */ 'components/kycUpgradeCountdownStrip/KycUpgradeCountdownStrip'
    )
);

export const KycRefreshDeadlineStrip = loadable(
  () =>
    import(
      /* webpackChunkName: "KycRefreshDeadlineStrip" */ /* webpackMode: "lazy" */ 'components/identity_verification/kycRefreshDeadlineStrip'
    )
);

export const TradingRevokedStrip = loadable(
  () =>
    import(
      /* webpackChunkName: "TradingRevokedStrip" */ /* webpackMode: "lazy" */ 'components/TradingRevokedStrip/tradingRevokedStrip'
    )
);

export const ResetPasswordPopup = loadable(
  () =>
    import(
      /* webpackChunkName: "ResetPasswordPopup" */ /* webpackMode: "lazy" */
      'components/resetPasswordPopup'
    )
);

export const MaintenanceBanner = loadable(
  () =>
    import(
      /* webpackChunkName: "MaintenanceBanner" */ /* webpackMode: "lazy" */ 'components/maintenance/notification'
    )
);

export const InformationStrip = loadable(
  () =>
    import(
      /* webpackChunkName: "InformationStrip" */ /* webpackMode: "lazy" */ 'components/InformationStrip'
    ),
  {
    resolveComponent: components => components.InformationStrip,
  }
);

export const ScalperOfferStrip = loadable(
  () =>
    import(
      /* webpackChunkName: "ScalperOfferStrip" */ /* webpackMode: "lazy" */ 'components/CustomStrips/ScalperOfferStrip'
    ),
  {
    resolveComponent: components => components.ScalperOfferStrip,
  }
);

export const KycUpgradeModal = loadable(
  () =>
    import(
      /* webpackChunkName: "KycUpgradeModal" */ /* webpackMode: "lazy" */ 'components/kycUpgradeModal/KycUpgradeModal'
    )
);

export const ForceAppUpdatePopup = loadable(
  () =>
    import(
      /* webpackChunkName: "ForceAppUpdatePopup" */ /* webpackMode: "lazy" */ 'components/forceAppUpdatePopup/forceAppUpdatePopup'
    )
);

export const AccountRefreshTriggerStrip = loadable(
  () =>
    import(
      /* webpackChunkName: "AccountRefreshTriggerStrip" */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ 'components/AccountRefreshTriggerStrip/AccountRefreshTriggerStrip'
    )
);
